const KeenSlider = window.KeenSlider
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class PairItWith extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.selectors = {
      slider: '.keen-slider',
      slides: '.keen-slider__slide',
    }
  }

  setupListeners () {
    super.setupListeners()

    this.observer = new MutationObserver((mutations, observer) => {
      const slide = this.querySelector(this.selectors.slides)

      if (!slide) {
        return
      }

      this.classList.remove('sec-Section-hidden')

      window.requestAnimationFrame(() => {
        this.setupCarousel()
      })
    })

    this.observer.observe(this, {
      childList: true,
      subtree: true,
    })
  }

  setupCarousel () {
    try {
      return new KeenSlider(
        this.querySelector(this.selectors.slider),
        {
          selector: this.selectors.slides,
          loop: false,
          mode: 'snap',
          rubberband: false,
          slides: {
            perView: 3.2,
            spacing: 10,
          },
          breakpoints: {
            '(min-width: 901px)': {
              slides: {
                perView: 3,
                spacing: 10,
              },
            },
          },
        },
        [
          setInitialised(),
          useArrows({
            container: this.els?.arrows?.element,
            next: this.els?.next?.element,
            previous: this.els?.previous?.element,
          }),
        ],
      )
    } catch (err) {
      console.error('Pair it with carousel failed to initialise', err.message)
    }
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.observer.disconnect()
  }
}

if (!customElements.get('pair-it-with')) {
  customElements.define('pair-it-with', PairItWith)
}
